import {
    isMobile,
    validEmail,
    isPassword,
    isChinese,
    isUserName,
	isStr,
	isRuleStr
} from "./validate";

// ! 电话号码
export const validateMobile = (rule, value, callback) => {
    if (!isMobile(value) && value) {
        callback(new Error('请输入正确的电话号码'));
    } else {
        callback();
    }
};

// ! 邮箱
export const validateEmail = (rule, value, callback) => {
    if (!validEmail(value) && value) {
        callback(new Error('请输入正确的邮箱'));
    } else {
        callback();
    }
};

// 用户名
export const validateAccount = (rule, value, callback) => {
    if(!value){
        callback(new Error("请输入登录名"));
    }else if(isChinese(value)){
        callback(new Error("登录名不能为中文"));
    }else if(value.length <3 || value.length > 25){
        callback(new Error("长度为3-25个字符"));
    }else if(!isUserName(value)){
        callback(new Error("只能为大小字母、数字和下划线"));
    }else{
        callback();
    }
}

// 昵称
export const validateNickname = (rule, value, callback) => {
    if(!value){
        callback(new Error("请输入昵称"));
    }else if(value.length <3 || value.length > 25){
        callback(new Error("长度为3-25个字符"))
    }else{
        callback();
    }
}

// 邮箱
export const validateRequiredEmail = (rule, value, callback) => {
    if(!value){
        callback(new Error('请输入邮箱'))
    }else if (!validEmail(value)) {
        callback(new Error('请输入正确的邮箱'));
    } else {
        callback();
    }
};

// 密码
export const validatePassword = (rule, value, callback) => {
    if(!value){
        callback(new Error('请输入密码'))
    }else if (!isPassword(value)) {
        callback(new Error('密码需包含写字母特殊符号数字且不少于8位'));
    } else {
        callback();
    }
};

// 品牌名称
export const validateBrandName = (rule, value, callback) => {
    if(!value){
        callback(new Error("请输入品牌名"))
    }else{
        callback();
    }
}

// 报表名称
export const validateReportName = (rule, value, callback) => {
    if(!value){
        callback(new Error("请输入报表名"))
    }else if(value.length <2 || value.length > 25){
        callback(new Error("长度为2-25个字符"))
    }else{
        callback();
    }
}

// 字母
export const validateStr = (rule, value, callback) => {
    if (value && !isStr(value)) {
        callback(new Error('仅支持大小写字母'));
    } else {
        callback();
    }
};


// 字母,数字长度8-32
export const validateRuleStr = (rule, value, callback) => {
    if(!value){
        callback(new Error("请输入规则代码"));
    }else if(value.length < 8 || value.length > 32 || !isRuleStr(value)){
        callback(new Error("仅支持长度为8~32位数字字母"))
    }else{
        callback();
    }
};
